import type { FC } from 'react';
import { Spin } from 'antd';

import { TPO_PROMO_METRICS_EMPTY, TPO_PROMO_METRICS_LOADING } from '../../../config/testIds';

interface PromoMetricsEmptyStateProps {
    title: string;
    subtitle?: string;
    /** Renders a spinner above the title instead of the muted panel background. */
    loading?: boolean;
}

const PromoMetricsEmptyState: FC<PromoMetricsEmptyStateProps> = ({ title, subtitle, loading = false }) => {
    if (loading) {
        return (
            <div
                className="flex flex-col items-center justify-center py-16 text-gray-400"
                data-testid={TPO_PROMO_METRICS_LOADING}
            >
                <Spin size="default" />
                <p className="text-sm">{title}</p>
            </div>
        );
    }

    return (
        <div
            className="flex flex-col items-center justify-center py-16 bg-gray-50"
            data-testid={TPO_PROMO_METRICS_EMPTY}
        >
            <p className="text-sm text-gray-500 font-medium">{title}</p>
            {subtitle ? (
                <p className="text-xs text-gray-400 mt-1" data-testid={`${TPO_PROMO_METRICS_EMPTY}_subtitle`}>
                    {subtitle}
                </p>
            ) : null}
        </div>
    );
};

PromoMetricsEmptyState.displayName = 'PromoMetricsEmptyState';

export default PromoMetricsEmptyState;
